export default __webpack_public_path__ + "locales/lo-LA/DeleteDialog.json?hash=7c63198c4d8ec24147d00a28c9bb48dc";